module.exports = __webpack_public_path__ + "img/project10_3.jpg.61cb688c.webp";